import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import CrudActionContainer from './CrudActionContainer';
import { StoreState } from '../store-interfaces';
import StartBotController, {
  StartBotPromoterCreateParams,
} from '../controllers/StartBotController';
import commonHandler from '../errorHandlers/common-handler';
import { PromoterTypes, LinkTypes } from '../model/PromoterModel';
import pageCRUDActions from './PageCRUDActions';

const PROMOTER_START_BOT_LOOKUP = {
  [PromoterTypes.CUSTOMER_CHAT]: 'qualify_leads',
  [PromoterTypes.FB_COMMENT_GUARD]: 'comment_guard',
  [PromoterTypes.AWAY_RESPONDER]: 'away_responder',
  [PromoterTypes.OPTIN]: 'optin',
  [PromoterTypes.INSTAGRAM_COMMENT_GUARD]: 'instagram_comment_guard',
  [PromoterTypes.FACEBOOK_CATCH_ALL_ENGAGEMENTS]: 'facebook_catch_all',
  [PromoterTypes.INSTAGRAM_CATCH_ALL_ENGAGEMENTS]: 'instagram_catch_all',
};

class StartBotCRUDActions extends CrudActionContainer {
  constructor() {
    super('START_BOT');
  }

  create(
    botId: number,
    kind: string,
    promoterParams?: StartBotPromoterCreateParams,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.createAction));
        const startBotKind = PROMOTER_START_BOT_LOOKUP[kind];

        const response = await StartBotController.create(
          botId,
          startBotKind,
          promoterParams,
        );

        dispatch(pageCRUDActions.retrieveAll(botId));

        dispatch(this.unbusy());
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  retrieveCampaignsStartBots(botId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        return StartBotController.retrieveCampaignStartbots(botId);
      } catch (err) {
        commonHandler(dispatch)(err);
      }
    };
  }
}

export const startBotCRUDActions = new StartBotCRUDActions();

export const useStartBotCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return {
    create: (
      botId: number,
      kind: LinkTypes,
      promoterParams?: StartBotPromoterCreateParams,
    ) => dispatch(startBotCRUDActions.create(botId, kind, promoterParams)),
    retrieveCampaignsStartBots: (botId: number) =>
      dispatch(startBotCRUDActions.retrieveCampaignsStartBots(botId)),
  };
};
